import { render, staticRenderFns } from "./HayaTable.vue?vue&type=template&id=34288bfc&"
import script from "./HayaTable.vue?vue&type=script&lang=js&"
export * from "./HayaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports